import axios from 'axios'
import config from './config'
let instance = axios.create({
    baseURL: config().licenseUrl

});

export default instance